const autoModals = document.querySelectorAll("[data-auto-modal]")

const Modal = {
	modifierClass: "is-visible",

	bindEvents: () => {
		if (!autoModals.length) return

		document.addEventListener("click", function (e) {
			autoModals.forEach(function (modal) {
				if (e.target.dataset.openModal === modal.id) {
					Modal.open(modal)
				} else if (e.target.dataset.closeModal === modal.id) {
					Modal.close(modal)
				}
			})
		})
	},

	open: (modal) => {
		Modal.checkModal(modal)
		modal.classList.add(Modal.modifierClass)
	},

	close: (modal) => {
		Modal.checkModal(modal)
		modal.classList.remove(Modal.modifierClass)
	},

	isOpen: (modal) => {
		Modal.checkModal(modal)
		return modal.classList.contains(Modal.modifierClass)
	},

	checkModal: (modal) => {
		if (!modal) {
			throw new Error("Le HTMLElement de la modal ciblée n'existe pas.")
		}
	},
}

export default Modal
